import * as Sentry from '@sentry/react'
import { ReactNode } from 'react'

interface Props {
  children: ReactNode
}

const ErrorBoundary = ({ children }: Props) => {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div className="flex min-h-[400px] items-center justify-center">
          <div className="text-center">
            <h2 className="mb-4 text-xl font-semibold">
              Det oppstod en feil i kalkulatoren
            </h2>
            <p className="mb-4 text-gray-600">
              {(error as Error)?.message || 'Noe gikk galt. Vennligst prøv igjen.'}
            </p>
            <button
              onClick={resetError}
              className="rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
            >
              Prøv igjen
            </button>
          </div>
        </div>
      )}
      beforeCapture={(scope, _error, errorInfo) => {
        scope.setContext('react', {
          componentStack: (errorInfo as { componentStack?: string }).componentStack,
        })
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  )
}

export default ErrorBoundary